// extracted by mini-css-extract-plugin
export default {"formGroup":"FormPhoneField_formGroup__FPG-e","errorInput":"FormPhoneField_errorInput__07pvc","nb":"FormPhoneField_nb__-LeXh"};